import { render } from "./TradeResult.vue?vue&type=template&id=465d0e30"
import script from "./TradeResult.vue?vue&type=script&lang=js"
export * from "./TradeResult.vue?vue&type=script&lang=js"

import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__